import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Product.css";

import SmartHome from "../assets/images/SmartHome.jpg";
import Electric from "../assets/images/Electrical.jpg";
import Electrical from "../assets/docs/ElectricalEquipment.pdf";
import Master from "../assets/docs/MasterSmartHome.pdf";

const Products = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  },[]);

  // ======== DATA STRUCTURE ==========
  const categories = [
    {
  name: "MASTER SMART HOME",
  products: [
    {
      name: "ILLUMINATION",
      items: [
        { label: "Rail-Mounted Switch SW-1CHL", id: "sw-1chl" },
        { label: "Rail-Mounted Switch SW-6CHL", id: "sw-6chl" },
        { label: "Rail-Mounted Dimmer SD-1CHL", id: "sd-1chl" },
        { label: "Flush-Mounted Switch SW-400B ", id: "sw-400b" },
        { label: "Flush-Mounted Dimmer SD-400B ", id: "sd-400b" },
        { label: "Smart Dimmer SD 1-10V ", id: "sd-v10" },
        { label: "Rail-Mounted Smart Dimmer SD-V10/R", id: "sd-v10r" },
        { label: "Smart LED Controller SD-250W", id: "sd-250w" },
        { label: "Smart LED Controller SD-RGB", id: "sd-rgb" },
        { label: "7 inch Touchscreen Controller SD-LCD", id: "sd-lcd" },
      ]
    },
    {
      name: "SHADING SYSTEMS",
      items: [
        { label: "Rolling Shutter and Shading system Controller", id: "sb-roll" },
        { label: "7 inch Touchscreen Controller SD-LCD", id: "sd-lcd" },
      ]
    },
    {
      name: "APPLIANCES CONTROL",
      items: [
        { label: "Rail-Mounted Switch SW-1CHL", id: "sw-1chl" },
        { label: "Rail-Mounted Switch SW-6CHL", id: "sw-6chl" },
        { label: "Flush-Mounted Switch SW-400B", id: "sw-400b" },
        { label: "Smart Socket and IR Controller SW-IR40", id: "sw-ir40" },
        { label: "7 inch Touchscreen Controller SD-LCD", id: "sd-lcd" },
      ]
    },
    {
      name: "HEATING / COOLING",
      items: [
        { label: "Smart ThermoStat ST-520/R ", id: "st-520r" },
        { label: "Smart Reciever ST-520-RV", id: "st-520rv" },
        { label: "Smart Fan Coil Controller ST-520FC", id: "st-520fc" },
      ]
    },
    {
      name: "VISUALIZATION",
      items: [
        { label: "Master Smart Home App", id: "mobile" },
        { label: "Online Management Application", id: "browser" },
      ]
    }
  ]
},
    {
      name: "LED CONTROLLERS",
      products: [
        { name: "LD-250W" },
        { name: "LD-250W-RF" },
        { name: "LD-250W-BST" },
        { name: "LD-RGB-BST" },
        { name: "LD-RGB" },
      ],
    },
    {
      name: "WALL – MOUNTING DIMMER",
      products: [{ name: "DM-400L/N" }, { name: "DM-1000W" }],
    },
    {
      name: "FLUSH – MOUNTING DIMMER",
      products: [{ name: "DM-400B" }, { name: "DM-400B-RF" }],
    },
    {
      name: "RAIL – MOUNTING DIGITAL DIMMER",
      products: [{ name: "DM-300/b" }, { name: "DM-DGL/b" }],
    },
    {
      name: "SURFACE – MOUNTING DIMMER",
      products: [
        { name: "DM-2500W" },
        { name: "DM-2500" },
        { name: "DM-PRO 1-10V" },
      ],
    },
  ];

  return (
    <section
      ref={sectionRef}
      className={`products-section fade-in-section ${
        isVisible ? "visible" : ""
      }`}
    >
      <div className="container">
        <h2 className="products-title">Our Products</h2>

        {/* ===== CATEGORY LIST ===== */}
        <div className="category-list">
  {categories.map((category, index) => (
    <div key={index} className="category-block">
      <h3 className="category-heading">{category.name}</h3>
      <hr className="category-line" />

      <ul className="product-list">
  {category.products.map((product, i) => (
    <li key={i} className="product-item">

      {/* MASTER SMART HOME (products with sub-items) */}
      {product.items ? (
        <details className="category-details">
          <summary className="product-code">{product.name}</summary>

          <ul className="subproduct-list">
            {product.items.map((item, j) => (
              <li key={j} className="subproduct-item">
                <Link to={`/products/${item.id}`} className="subproduct-link">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </details>
      ) : (
        /* NORMAL PRODUCTS (LED controllers, dimmers, etc) */
        <Link to={`/products/${product.name.toLowerCase().replace(/\s+|\//g, "-")}`} className="product-code">
          {product.name}
        </Link>
      )}

    </li>
  ))}
</ul>

    </div>
  ))}
</div>


        {/* ===== DOWNLOAD SECTION ===== */}
        <div className="downloads-section">
          <h2 className="downloads-title">Product Catalogue</h2>

          <div className="downloads-grid">
            <div className="download-card">
              <img src={SmartHome} alt="MASTER Smart Home" />
              <h3>MASTER Smart Home</h3>
              <a href={Master} target="_blank" rel="noopener noreferrer">
                View PDF
              </a>
            </div>

            <div className="download-card">
              <img src={Electric} alt="Electrical Equipment" />
              <h3>Electrical Equipment</h3>
              <a href={Electrical} target="_blank" rel="noopener noreferrer">
                View PDF
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
